import { useGetBuildingRebookerActive } from 'src/lib/hooks/use-get-rebooker-active';
import { useGetIsValidRebooker } from 'src/lib/hooks/use-get-is-valid-rebooker';

export const useRebookerFlow = (roomCode: string, isRebooker: boolean) => {
    const { data: isBuildingInRebookerPhase, isLoading: isBuildingRebookerLoading } =
        useGetBuildingRebookerActive(roomCode, isRebooker);

    const isRebookerFlowActive =
        isRebooker && !isBuildingRebookerLoading && Boolean(isBuildingInRebookerPhase);

    const { data: isValidRebookerResponse, isLoading: isValidRebookerLoading } =
        useGetIsValidRebooker(roomCode, isRebookerFlowActive);

    return {
        isRebookerFlowActive,
        isBuildingInRebookerPhase,
        isValidRebooker: isValidRebookerResponse ?? null,
        isLoading: isBuildingRebookerLoading || isValidRebookerLoading,
    };
};
